/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2023-07-13 16:17:26
 */
import * as type from '../action-types'
import { codeLogin, userCenterInfo, hbsgslLogin } from '@/api/login'
import { Toast } from 'vant'
import { setCookie } from '@/utils/cookies'
import to from 'await-to'
import { accountLogin } from '../../api/login'
export default {
  state: {
    token: '',
    userInfo: {},
  },
  mutations: {
    [type.SET_USER_INFO](state, payload) {
      state.userInfo = payload
      setCookie('userInfo', payload)
    },
    [type.SET_TOKEN](state, payload) {
      state.token = payload
      setCookie('myToken', payload)
    },
  },
  actions: {
    async [type.LOGIN]({ commit }, formData) {
      const [res, err] = await to(codeLogin(formData))
      if (err) {
        Toast(err.msg)
        return err
      }
      commit(type.SET_USER_INFO, res.data)
      commit(type.SET_TOKEN, res.data.token)
      return res
    },
    async [type.ACCOUNT_LOGIN]({ commit }, formData) {
      const [res, err] = await to(accountLogin(formData))
      if (err) return Toast(err.msg)
      commit(type.SET_USER_INFO, res.data)
      commit(type.SET_TOKEN, res.data.token)
      return res
    },
    async [type.HBSGSL_LOGIN]({ commit }, formData) {
      const [res, err] = await to(hbsgslLogin(formData))
      if (err) return Toast(err.msg)
      commit(type.SET_USER_INFO, res.data)
      commit(type.SET_TOKEN, res.data.token)
      return res
    },
    async [type.LOGOUT]({ commit }) {
      commit(type.SET_USER_INFO, {})
      commit(type.SET_TOKEN, '')
      return '退出成功'
    },
    async [type.GET_USER_INFO]({ commit }) {
      const [res, err] = await to(userCenterInfo())
      if (err) return Toast(err.msg)
      commit(type.SET_USER_INFO, res.data)
      return res
    },
  },
}
